import React from 'react';
import DataGrid, { Column, Editing, Paging, Lookup, RequiredRule, EmailRule, PatternRule, StringLengthRule,Form,Position, FilterRow } from 'devextreme-react/data-grid';
import { Item } from 'devextreme-react/form';
import { CheckBox } from 'devextreme-react/check-box';
import { commonServices } from '../../services/common.service';
import{userServices} from "../../services/user.service";
import notify from 'devextreme/ui/notify';
import { Popup } from 'devextreme-react/popup';
import "react-datepicker/dist/react-datepicker.css";
/**import Form from 'devextreme-react/form';*/

const cellRender = (data) => <a href={'timeline?id=' + data.value}>View Timeline</a>;

export class Users extends React.Component {
  constructor(props) {
    super(props);
    var user;
    this.state = { roles:[], users:[], header:"" , roleType:localStorage.getItem('roleType'), showViewTimeline:true, popupVisible: true, user,
    UserName :"",FullName:"",Email:"",PhoneNumber:"",  ToTrialDate: new Date(),FromTrialDate: new Date(), enableFilter:false};

    this.onRowUpdating = this.update.bind(this);
    this.onRowRemoving = this.remove.bind(this);
    this.onRowInserting = this.insert.bind(this);

    this.handleChange_FromTrialDate = this.handleChange_FromTrialDate.bind(this);
    this.handleChange_ToTrialDate = this.handleChange_ToTrialDate.bind(this);

    this.refreshUsers();
 
    this.passwordOptions = {
      mode: 'password'
    };
    this.phoneEditorOptions = {
      mask: '+1 (X00) 000-0000',
      maskRules: {
        X: /[02-9]/
      },
      useMaskedValue: true,
      maskInvalidMessage: 'The phone must have a correct USA phone format'
    };

    //get all roles
    userServices.getAllRoles().then(
        data=>{
          if(this.state.roleType==='1'){
            this.setState({ roles: data, header:"User Management", showViewTimeline:true});
          }
          else{
            var listRoles =data.filter(x=>x.roleType===3|| x.roleType===4);//caregiver and Therapist
            this.setState({roles:listRoles, header:"Caregiver/Therapist Management", showViewTimeline:false})
          }
        },
        error=>{
          notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
        }
    );
  }

  refreshUsers(){
    if(this.state.roleType==='1')//admin
    {
      userServices.getAll().then(
        data=>{
          this.setState({ users: data, showViewTimeline:true});
          if(data.length>0){
            this.setState({enableFilter:true});
          }
          else{
            this.setState({enableFilter:false});
          }
        },
        error=>{
          notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
        }
      );
    }
    else{//parent
      userServices.getUserCreatedByParent(localStorage.getItem('userId')).then(
        data=>{
          this.setState({ users: data, showViewTimeline:false});
          if(data.length>0){
            this.setState({enableFilter:true});
          }
          else{
            this.setState({enableFilter:false});
          }

        },
        error=>{
          notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
        }
      );
    }
  }
  
  insert(event){
    var addedRow = event.data;
    addedRow.roles=[addedRow.roles];
    var password=commonServices.generatePassword();
    addedRow.newPassword=password;
    if(!addedRow.isEnabled){
      addedRow.isEnabled=true;
    }
    userServices.register(addedRow).then(
      response=>{
        if(response){
          notify({position:'top right', message:'Added successfully',type:'success',maxWidth:200});
          this.refreshUsers();
          //send email
          userServices.sendEmail(addedRow.email, addedRow.userName, addedRow.newPassword).then(
            response=>{
              notify({position:'top right', message:"The user name and password have been sent to user's email. ",type:'success',maxWidth:200});
            },
            error=>{
              notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
            }
          );
        }
      }, 
      error=>{
        notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
        this.refreshUsers();
      }
    );
  }
  
  update(event){  
    let { users } = this.state;
    var newData=event.newData;
    if(newData.roles)
    {
      newData.roles=[newData.roles];
    }
    users = users.map(user => (user.id===event.key ? { ...user, ...newData } : user));
    var changedRow;
    users.forEach(user => {
      if(event.key===user.id)
        changedRow= user;
    });
    if(changedRow){
      userServices.update(changedRow).then(
        ()=>{
            notify({position:'top right', message:'Updated successfully',type:'success',maxWidth:200});
        }, 
        error=>{
          notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
          this.refreshUsers();
        }
      );
    }
  }

  remove(event){
    userServices.delete(event.key).then(
      response=>{
        if(response){
          notify({position:'top right', message:'Deleted successfully',type:'success',maxWidth:200});
        }
      }, 
      error=>{
        notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
        this.refreshUsers();
      }
    );
  }
  handleChange_FromTrialDate(date) {
    this.setState({
      FromTrialDate: date
    });
  }

  handleChange_ToTrialDate(date) {
    this.setState({
      ToTrialDate: date
    });
  }

  render() {
    //const {UserName,      FullName,      Email,      PhoneNumber,      FromTrialDate,      ToTrialDate} = this.state;
    return (
      <div>
        <h4>{this.state.header}</h4>
        <React.Fragment>
          <DataGrid
            id={'gridContainer'}
            dataSource={this.state.users}
            keyExpr={'id'}
            allowColumnReordering={true}
            showBorders={true}
            showRowLines= {true}       
            onRowUpdating={this.onRowUpdating}
            onRowRemoving={this.onRowRemoving}
            onRowInserting={this.onRowInserting}
            >
            <FilterRow visible={this.state.enableFilter} applyFilter={'Immediately'} />
            <Paging enabled={true} />
            <Editing
              allowDeleting={true}
              mode={'popup'}
              allowUpdating={true}
              allowAdding={true}>
              <Popup title={'Employee Info'} showTitle={true} width={600} height={100}>
                <Position my={'top'} at={'top'} of={window} />
              </Popup>
              <Form>
                <Item itemType={'group'} colCount={2} colSpan={2}>
                  <Item dataField={'userName'} />
                  <Item dataField={'fullName'} />
                  <Item dataField={'email'}/>
                  <Item dataField={'roles'} />
                  <Item dataField={'phoneNumber'} editorOptions= {this.phoneEditorOptions}>
                  </Item>                  
                </Item>
                <Item itemType={'group'} caption={'Active Information'} colCount={2} colSpan={2}>
                  <Item dataField={'fromTrialDate'} />
                  <Item dataField={'toTrialDate'} />
                  <Item dataField={'isEnabled'} />           
                </Item>
                <CheckBox defaultValue={false} />
                <div className={'dx-field'}>
                  <div className={'dx-field-label'}>With label</div>
                  <div className={'dx-field-value'}>
                    <CheckBox
                      defaultValue={true}
                      width={80}
                      text={'Check'}
                    />
                  </div>
                </div>
              </Form>
            </Editing>

            {/* <Column dataField={'id'} caption={'ID'}/> */}
            <Column dataField={'userName'} caption={'User Name'}>
              <RequiredRule />
              <StringLengthRule min={2} max={200} message={"User Name must be between 2 and 200 characters"}/>
              <PatternRule
                message={'User Name must be alphanumeric character'}
                pattern={"^[a-zA-Z0-9_.-]*$"}
              />
            </Column>
            <Column dataField={'fullName'} caption={'Full Name'}/>
            <Column dataField={'email'} caption={'Email'}>
              <RequiredRule />
              <EmailRule />
            </Column>
            <Column dataField={'roles'} caption={'Role'}>
              <Lookup dataSource={this.state.roles} displayExpr={'name'} valueExpr={'name'} />
              <RequiredRule />
            </Column>
            <Column dataField={'phoneNumber'} caption={'Phone Number'}/>
            
            <Column dataField={'fromTrialDate'} dataType={'date'} format={'MM/dd/yyyy'} /> 
            <Column dataField={'toTrialDate'} dataType={'date'}  format={'MM/dd/yyyy'} />

            <Column dataField={'isEnabled'} caption={'Activated'} dataType={'boolean'}  width={80}/>
            <Column dataField={'id'} caption={''} cellRender={cellRender}  width={100} visible={this.state.showViewTimeline} allowFiltering = {false}/>
          </DataGrid>
        </React.Fragment>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/Admin/Users.js